jQuery(document).ready(function(){
    window.onscroll = function() {
        if (window.pageYOffset >= 150){
            jQuery('.site-header').addClass('APPLE');
        }
        else {
            jQuery('.site-header').removeClass('APPLE');
        }
    }
});